import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
`

export const Title = styled.h2`
  margin-bottom: 20px;
`

export const CartValue = styled.div`
  background-color: ${colors.ohLightCream};
  padding: 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-family: AvenirDemi;
`
export const Subheading = styled.div`
  font-family: AvenirDemi;
  font-size: 16px;
  margin-bottom: 16px;
`
export const PaymentSummary = styled.div`
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: white;
`

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`

// The server sends a `sub_label` on some breakup lines ("starts sat, 15 aug | 10:00-12:00",
// the kit's subject). It belongs under its label, not beside it, or the row wraps badly at
// modal width.
export const SummaryLabel = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 12px;
`

export const SummarySubLabel = styled.span`
  font-size: 11px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.5);
`

export const SummaryItemEnd = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`

export const TotalPayable = styled(SummaryItem)`
  font-weight: bold;
  border-top: 1px dotted #0000001f;
  padding-top: 6px;
`

export const ActionButton = styled.button`
  background-color: ${colors.ohOrange};
  font-family: AvenirDemi;
  font-size: 18px;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 24px;
  width: 100%;
  cursor: pointer;
`

export const CoinImageContainer = styled.div`
  height: 20px;
  width: 20px;
`

// export const TotalText = styled.span``

export const TotalAmount = styled.span`
  color: ${colors.ohOrange};
  border-radius: 24px;
  border: 1px solid ${colors.ohOrange};
  padding: 2px 8px;
  display: flex;
  align-items: center;
`

export const CoinImg = styled.img`
  margin-top: -1px;
  margin-right: 2px;
  height: 16px;
  width: 16px;
`
export const CoinsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`

export const ActionsContainer = styled.div`
  margin-top: auto;
`
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Separator = styled.div`
  margin-top: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 12px;
`

export const LineEntryTextSpan = styled.div`
  color: ${(props) => props.color || 'inherit'};
  font-weight: ${(props) => props.fontWeight || '400'};
`

export const DottedSeparater = styled.div`
  border-bottom: 1px dotted #0000001f;
  margin-bottom: 6px;
`
export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: ${colors.ohOrange};
`
export const ProgramContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  background: #f8f8f8;
  padding: 16px;
  padding-top: 20px;
  border-radius: 12px;
  margin-bottom: 12px;
`

// Autopay checkouts commit the parent to a future debit rather than to a payment
// made at the counter, so both of them carry a plain-language note about what
// happens next. Deliberately loud: the failure mode this guards against is a
// centre user believing the child is booked when they are not.
export const Notice = styled.div`
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff6f3;
  border: 1px solid ${colors.ohOrange};
  font-size: 13px;
  line-height: 20px;
`
